import { makeCrewLoaderWithLineItemClaims, redirect } from '~/utils/routing';
import {
  claimAddressSchema,
  claimAddressSchemaRequiredPhone,
} from '~/utils/schemas';
import { isAddressPhoneRequired } from '~/utils/theme';

export const { loader, useLoaderData: useAddressData } =
  makeCrewLoaderWithLineItemClaims(({ context }) => {
    const addressSchema =
      isAddressPhoneRequired(context.settings.theme, context.claimType) ?
        claimAddressSchemaRequiredPhone
      : claimAddressSchema;

    const result = addressSchema.safeParse(
      context.address ?? context.order.shippingAddress,
    );

    return result.success ? result.data : redirect('./edit');
  });
